import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CorrelationIdService } from './correlation-id.service';

@NgModule({
  imports: [CommonModule],
  providers: [CorrelationIdService],
})
export class CorrelationIdModule {}
